import { render, staticRenderFns } from "./WebDataRocks.vue?vue&type=template&id=0d87f838&scoped=true"
import script from "./WebDataRocks.vue?vue&type=script&lang=js"
export * from "./WebDataRocks.vue?vue&type=script&lang=js"
import style0 from "./WebDataRocks.vue?vue&type=style&index=0&id=0d87f838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d87f838",
  null
  
)

export default component.exports